import { Color } from '@nect/ui/theme/color';
import styled, { css } from 'styled-components';

import { ITextParagraphProps, ITextProps } from '.';

const TextButtonBase = css`
    font-family: ${(props) => props.theme.button.fontFamily};
    font-style: normal;
    color: ${(props) =>
        (props as any).color
            ? props.theme.color[(props as any).color as Color]
            : 'inherit'};
`;

// Button Large
export const TextButtonLargeCSS = css`
    ${TextButtonBase}
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
`;

const TextButtonLargeStyled = styled.span`
    ${TextButtonLargeCSS}
`;

// Button Medium
export const TextButtonMediumCSS = css`
    ${TextButtonBase}
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
`;

const TextButtonMediumStyled = styled.span`
    ${TextButtonMediumCSS}
`;

// Button Small
export const TextButtonSmallCSS = css`
    ${TextButtonBase}
    font-weight: 600;
    font-size: 11px;
    line-height: 14px;
`;

const TextButtonSmallStyled = styled.span`
    ${TextButtonSmallCSS}
`;

const TextBase = css`
    font-family: ${(props) => props.theme.text.fontFamily};
    font-style: normal;
    color: ${(props) =>
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        props.theme.color[((props as any).color as Color) ?? Color.grey700]};
`;

/* Text Body Large */
export const TextBodyLargeCSS = css`
    ${TextBase}
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: -1px;
`;

const TextBodyLargePStyled = styled.p<ITextParagraphProps>`
    ${TextBodyLargeCSS}
    text-align: ${(props) => props.align ?? 'left'};
`;

const TextBodyLargeSpanStyled = styled.span<ITextProps>`
    ${TextBodyLargeCSS}
    display: inline-block;
`;

/* Text Body Medium */
export const TextBodyMediumCSS = css`
    ${TextBase}
    font-weight: 400;
    font-size: 21px;
    line-height: 24px;
    letter-spacing: -1px;
`;

const TextBodyMediumPStyled = styled.p<ITextParagraphProps>`
    ${TextBodyMediumCSS}
    text-align: ${(props) => props.align ?? 'left'};
`;

const TextBodyMediumSpanStyled = styled.span<ITextProps>`
    ${TextBodyMediumCSS}
    display: inline-block;
`;

/* Text Body Regular */
export const TextBodyRegularCSS = css`
    ${TextBase}
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: -1px;
`;

const TextBodyRegularPStyled = styled.p<ITextParagraphProps>`
    ${TextBodyRegularCSS}
    text-align: ${(props) => props.align ?? 'left'};
`;

const TextBodyRegularSpanStyled = styled.span<ITextProps>`
    ${TextBodyRegularCSS}
    display: inline-block;
`;

/* Text Body Small */
export const TextBodySmallCSS = css`
    ${TextBase}
    font-weight: 400;
    font-size: 13px;
    line-height: 19px;
    letter-spacing: -0.5px;
`;

const TextBodySmallPStyled = styled.p<ITextParagraphProps>`
    ${TextBodySmallCSS}
    text-align: ${(props) => props.align ?? 'left'};
`;

const TextBodySmallSpanStyled = styled.span<ITextProps>`
    ${TextBodySmallCSS}
    display: inline-block;
`;

/* Footnote Medium */
export const TextFootnoteMediumCSS = css`
    ${TextBase}
    font-weight: 500;
    font-size: 11px;
    line-height: 14px;
    letter-spacing: -0.25px;
`;

const TextFootnoteMediumPStyled = styled.p<ITextParagraphProps>`
    ${TextFootnoteMediumCSS}
    text-align: ${(props) => props.align ?? 'left'};
`;

const TextFootnoteMediumSpanStyled = styled.span<ITextProps>`
    ${TextFootnoteMediumCSS}
    display: inline-block;
`;

/* Footnote Thin */
export const TextFootnoteSmallCSS = css`
    ${TextBase}
    font-weight: 400;
    font-size: 11px;
    line-height: 14px;
    letter-spacing: -0.5 px;
`;

const TextFootnoteSmallPStyled = styled.p<ITextParagraphProps>`
    ${TextFootnoteSmallCSS}
    text-align: ${(props) => props.align ?? 'left'};
`;

const TextFootnoteSmallSpanStyled = styled.span<ITextProps>`
    ${TextFootnoteSmallCSS}
    display: inline-block;
`;

/* Tiny Regular */
export const TextTinyRegularCSS = css`
    ${TextBase}
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.01em;
`;

const TextTinyRegularPStyled = styled.p<ITextParagraphProps>`
    ${TextTinyRegularCSS}
    text-align: ${(props) => props.align ?? 'left'};
`;

const TextTinyRegularSpanStyled = styled.span<ITextProps>`
    ${TextTinyRegularCSS}
    display: inline-block;
`;

// To prevent duplicated auto completion for *Styled exports
// eslint-disable-next-line import/no-default-export
export default {
    TextButtonSmallStyled,
    TextButtonMediumStyled,
    TextButtonLargeStyled,

    TextBodyLargePStyled,
    TextBodyMediumPStyled,
    TextBodyRegularPStyled,
    TextBodySmallPStyled,
    TextFootnoteMediumPStyled,
    TextFootnoteSmallPStyled,
    TextTinyRegularPStyled,

    TextBodyLargeSpanStyled,
    TextBodyMediumSpanStyled,
    TextBodyRegularSpanStyled,
    TextBodySmallSpanStyled,
    TextFootnoteMediumSpanStyled,
    TextFootnoteSmallSpanStyled,
    TextTinyRegularSpanStyled,
};
